import axios from "axios";

export default axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'ocp-apim-subscription-key': process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY
  }
});
